// Formats de dates/periodes locale-aware pour les ecrans equipes (E1b, i18n
// FR+EN). Reutilise formatDate/formatDateOnly des comites (source unique) et
// ajoute les helpers de PERIODE 'YYYY-MM' (jauge pulse, historique) — miroir
// locale-aware de src/lib/pulse/period.ts du PoC (fr-CA seulement en PoC).

import type { SupportedLocale } from '../../i18n';

export { formatDate, formatDateOnly } from '../comites/dates';

const intlLocale = (locale: string): string => (locale.startsWith('en') ? 'en-CA' : 'fr-CA');

/** 'YYYY-MM' -> forme longue locale (« juin 2026 » / « June 2026 »), rendu UTC. */
export function formatPeriodLong(locale: SupportedLocale | string, period: string): string {
  const [year, month] = period.split('-').map(Number);
  if (!year || !month) return period;
  return new Intl.DateTimeFormat(intlLocale(locale), {
    month: 'long', year: 'numeric', timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, 1)));
}

/** 'YYYY-MM' -> mois court locale (« juin » / « Jun ») pour les cellules compactes. */
export function monthShort(locale: SupportedLocale | string, period: string): string {
  const [year, month] = period.split('-').map(Number);
  if (!year || !month) return period;
  return new Intl.DateTimeFormat(intlLocale(locale), { month: 'short', timeZone: 'UTC' }).format(
    new Date(Date.UTC(year, month - 1, 1)),
  );
}

/**
 * true si l'echeance (YYYY-MM-DD) tombe dans <= `days` jours (badge « echeance
 * proche »). Comparaison de chaines locales (pas d'UTC — evite le decalage de
 * fuseau, meme convention que deadlineSoonLimit du PoC/E1b). Reutilise par les
 * affichages (E1d) et la laterale « affichages ouverts » de la fiche equipe (E1b).
 */
export function isDeadlineSoon(deadline: string | null | undefined, days = 7): boolean {
  if (!deadline) return false;
  const d = new Date();
  d.setDate(d.getDate() + days);
  const p = (n: number) => String(n).padStart(2, '0');
  const limit = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  return deadline <= limit;
}

/** Decale une periode 'YYYY-MM' de `delta` mois (miroir shiftPeriod PoC). */
export function shiftPeriod(period: string, delta: number): string {
  const [year, month] = period.split('-').map(Number);
  if (!year || !month) return period;
  const d = new Date(Date.UTC(year, month - 1 + delta, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}
